<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1654_7124)">
      <path
        d="M7.99967 14.6668C4.31767 14.6668 1.33301 11.6822 1.33301 8.00016C1.33301 4.31816 4.31767 1.3335 7.99967 1.3335C11.6817 1.3335 14.6663 4.31816 14.6663 8.00016C14.6663 11.6822 11.6817 14.6668 7.99967 14.6668ZM7.33301 10.0002V11.3335H8.66634V10.0002H7.33301ZM7.33301 4.66683V8.66683H8.66634V4.66683H7.33301Z"
        fill="#FDAD35"
      />
    </g>
    <defs>
      <clipPath id="clip0_1654_7124">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
